module.exports = __webpack_public_path__ + "img/w3_circle_pause_dark.6c97d9b7.png";